export var FETCH_CAMPAIGN_REQUEST = 'FETCH_CAMPAIGN_REQUEST';
export var FETCH_CAMPAIGN_SUCCESS = 'FETCH_CAMPAIGN_SUCCESS';
export var FETCH_CAMPAIGN_ERROR = 'FETCH_CAMPAIGN_ERROR';
export var UPDATE_DOCUMENT_REQUEST = 'UPDATE_DOCUMENT_REQUEST';
export var UPDATE_DOCUMENT_SUCCESS = 'UPDATE_DOCUMENT_SUCCESS';
export var UPDATE_DOCUMENT_ERROR = 'UPDATE_DOCUMENT_ERROR';
export var LAUNCH_CAMPAIGN = 'LAUNCH_CAMPAIGN';
